export const workData = [
  // comment
  {
    title: 'Install the app',
    image: '/assets/images/how_it_works/HowItWorks_1.png',
    content: [
      {
        description:
          'You can install the application from the Google Play Store or Sikka’s official website.',
        list: {
          points: true,
          items: [
            {
              description: 'Go to the Google Play Store.'
            },
            {
              description: 'Type Sikka in the search bar.'
            },
            {
              description: 'Click Install.'
            }
          ]
        }
      },
      {
        description: 'The app is added to your Android device.'
      }
    ]
  },
  {
    title: 'Complete the verification',
    image: '/assets/images/how_it_works/HowItWorks_2.png',
    content: [
      {
        description:
          'Verify your mobile number and email address to be a verified user on Sikka.',
        list: {
          points: true,
          items: [
            {
              description: 'Install the app from the Play Store.'
            },
            {
              description:
                'Sign in by entering your mobile number and email address.'
            },
            {
              description: 'Enter the OTP to verify.'
            }
          ]
        }
      }
    ]
  },
  {
    title: 'Build your profile',
    image: '/assets/images/how_it_works/HowItWorks_3.png',
    content: [
      {
        description:
          'Set up a user profile by adding details on the Sikka app for a better user experience.',
        list: {
          points: true,
          items: [
            {
              description: 'Install the app from the Play Store.'
            },
            {
              description: 'Sign in to the app by verifying your mobile number.'
            },
            {
              description: 'Go to the Profile section.'
            },
            {
              description: 'Update your profile information.'
            }
          ]
        }
      }
    ]
  },
  {
    title: 'Enjoy the benefits',
    image: '/assets/images/how_it_works/HowItWorks_4.png',
    content: [
      {
        description:
          'After the setup is complete, you can enjoy the perks of Sikka by earning daily cash.'
      }
    ]
  },
  {
    title: 'Get multiple ways to earn',
    image: '/assets/images/how_it_works/HowItWorks_5.png',
    content: [
      {
        description:
          'Gain as many Sikkas as possible in multiple ways and fill your Sikka wallet with rewards. Some easy ways to earn money from Sikka are as follows:',
        list: {
          points: false,
          items: [
            {
              title: 'Check in daily',
              description:
                'Daily check-in is an option where you check in to Sikka daily, complete the offer, and earn Sikka.'
            },
            {
              title: 'Complete interesting offers',
              description:
                'Complete simple offers and earn money. Make sure you complete all the steps in the offer to gain all the Sikkas.'
            },
            {
              title: 'Refer and earn',
              description:
                'Refer Sikka to your friends and earn 50% of what they earn. The more people you refer, the more Sikka coins you earn!'
            },
            {
              title: 'Enter into contests',
              description:
                'Join and compete in weekly contests with other Sikka app users to earn redeemable Sikka coins!'
            }
          ]
        }
      }
    ]
  },
  {
    title: 'Earn and redeem exciting rewards',
    image: '/assets/images/how_it_works/HowItWorks_6.png',
    content: [
      {
        description:
          'Gain rewards from exciting offers and redeem your daily earnings from the Sikka wallet.',
        list: {
          points: true,
          items: [
            {
              description: (
                <>
                  View the offers under <span>‘My Offers’</span>,{' '}
                  <span>‘All Offers’</span>, or{' '}
                  <span>‘Highest Paying Offers’</span>.
                </>
              )
            },
            {
              description: 'Click on an offer to see the offer details.'
            },
            {
              description: 'Complete the tasks mentioned on the offer.'
            },
            {
              description: 'Come back to the offer and click Redeem.'
            },
            {
              description: 'Choose the transfer method.'
            },
            {
              description: 'Enter the details and redeem your rewards.'
            }
          ]
        }
      }
    ]
  },
  {
    title: 'Redemption policy',
    image: '/assets/images/how_it_works/HowItWorks_7.png',
    content: [
      {
        description:
          'Transfer your daily earnings straight from your Sikka wallet into your bank accounts. You can transfer your Sikka coins to your bank account through  UPI.'
      }
    ]
  }
];
